import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import axios from "axios";
import { apiGateway } from "./config";
import { ConfirmationServiceProvider } from "./components/ConfirmationService";
import { SearchProvider } from "./context/SearchContext";
import { SourceFilterProvider } from "./context/SourceFilterContext.js";
import { SalesProvider } from './context/SalesContext.js';
import { SWRConfig } from "swr";
axios.defaults.baseURL = apiGateway;
const fetcher = async (resource) => {
  const r = await axios.get(resource, {
    headers: { "x-api-key": process.env.REACT_APP_X_API_KEY_CRM },
  });
  return r.data;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
<React.StrictMode>
    <ThemeProvider attribute="class">
      <BrowserRouter>
        <SourceFilterProvider>
          <SWRConfig value={{ fetcher: fetcher }}>

            <ConfirmationServiceProvider>
              <SearchProvider>
              <SalesProvider>
                  <App />
                </SalesProvider>
              </SearchProvider>
            </ConfirmationServiceProvider>
          </SWRConfig>

        </SourceFilterProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);


reportWebVitals();
